import React from 'react';
import { UITheme } from './WorkspaceUI';
import brandIcon from '../V9/assets/henosis-app-icon.png';
import './AuthLayout.css';

// Presentation only. Auth/bootstrap and lazy route gates still live in App.
export default function AppLoading() {
  return <UITheme className="auth-shell auth-loading">
    <main aria-label="Loading Henosis">
      <div className="ui-brand"><img src={brandIcon} alt="" />henosis</div>
      <p role="status" aria-live="polite">Loading your workspace…</p>
    </main>
  </UITheme>;
}
